import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon, Menu, Message, Popup, SemanticICONS } from 'semantic-ui-react';
import { RouteTypes } from '../../routes/constants';
import { El } from './style';
import Languages from './Languages';
import { useAuth } from '~/routes/components/AuthProvider';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'styled-components';
import { FARMER_ROLE_SLUG, ThemeType } from '~/Constants';
import ProfileApi from '~/api/services/profile'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Support from './Support';
import Timer from '../Timer';

import Favicon from 'react-favicon';
import Notifications from './Notifications';

const TopBar: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const {
    systemData,
    systemData: { logged: { roleSlug }, isTest },
    supportData,
    systemData: { faqSettings, modules },
    onLogout
  } = useAuth();
  const logoutTime = systemData?.roleSettings?.logoutTime
  const faqText = systemData?.texts?.find(text => text.slug === 'faq_text')
  const testPlatformText = systemData?.texts?.find(text => text.slug === 'test_platform_text')
  const navigate = useNavigate();
  const { logoTitle, favIcon } = useContext<ThemeType>(ThemeContext);
  const farmerLogged = roleSlug === FARMER_ROLE_SLUG
  const displayFaqTopBar = faqSettings.positions.find(position => position === 'header') && Boolean(faqSettings.status) &&
    modules.find(module => module.slug === 'faq')

  const [avatar, setAvatar] = useState('')

  useEffect(() => {
    fetchFileProfile()
  }, [])

  async function fetchFileProfile() {
    try {
      const response = await ProfileApi.getFileProfile()
      setAvatar(response.data)
    } catch (error) {
      // do nothing
    }
  }

  const leftSide = () => {
    return <El.BrandLogo
      key={'1'}
      style={{ backgroundImage: `url(${logoTitle})`, filter: 'drop-shadow(2px 4px 6px black)' }}
    ></El.BrandLogo>
  }

  const rightSide = () => (
    <>
      {Boolean(isTest) && <El.StyledMenuItemText key={'testPlatformText'}>
        <El.StyledTextWrapper>
          <Popup
            content={testPlatformText?.translation}
            trigger={<Icon name='info circle' />}
          />
          <div className='text'>{testPlatformText?.translation}</div>
        </El.StyledTextWrapper>
      </El.StyledMenuItemText>
      }
      <Menu.Item onClick={() => navigate(RouteTypes.PROFILE)} key={'1'}>
        <Popup
          content={t('My user profile')}
          trigger={
            <div
              style={{ display: 'flex', color: 'white', cursor: 'pointer', alignItems: 'center' }}
            >
              {avatar ? <El.StyledProfileWrapper>
                <LazyLoadImage
                  alt={''}
                  effect='blur'
                  src={avatar} />
              </El.StyledProfileWrapper> : <Icon name='user circle' size='big' />}
              <p style={{ fontSize: 15, fontWeight: 500, marginLeft: 5 }}>
                {systemData?.logged.name}
              </p>
            </div>
          }
        />
      </Menu.Item>
      {logoutTime > 0 && <Menu.Item style={{ padding: '0px 1.14285714em' }} key={'timer'}>
        <Timer logoutTime={logoutTime} />
      </Menu.Item>
      }
      {displayFaqTopBar && <Menu.Item onClick={() => navigate(RouteTypes.FAQ)} key={'3'}>
        <Popup
          content={faqText.translation}
          trigger={
            <div
              style={{ display: 'flex', color: 'white', cursor: 'pointer', alignItems: 'center' }}
            >
              <Icon name={faqSettings?.icon as SemanticICONS} size='large' />
            </div>
          }
        />
      </Menu.Item>
      }
      <Menu.Item key={'5'}>
        <Languages />
      </Menu.Item>
      <Menu.Item onClick={() => navigate(RouteTypes.PROFILE_SETTINGS)} key={'2'}>
        <Popup
          content={t('Profile settings')}
          trigger={
            <div
              style={{ display: 'flex', color: 'white', cursor: 'pointer', alignItems: 'center' }}
            >
              <Icon name='cog' size='large' />
            </div>
          }
        />
      </Menu.Item>
      {farmerLogged && <Menu.Item key={'8'}>
        <Notifications />
      </Menu.Item>}
      {/*  {farmerLogged && loginPopups.length > 0 && <Menu.Item
        onClick={() => {
          setSystemData({ ...systemData, openedLoginPopups: false })
          setStateTrackPopusLogin(false)
        }}
        key={'login-popups'}
      >
        <Popup
          content={t('Login popups')}
          trigger={
            <Icon size='large' name='user' style={{ color: 'white', cursor: 'pointer' }} />
          }
        />
      </Menu.Item>
      } */}
      {Boolean(supportData?.status) && farmerLogged && <Menu.Item key={'support'}>
        <Support />
      </Menu.Item>
      }
      <Menu.Item
        onClick={() => onLogout()}
        key={'6'}
      >
        <Popup
          content={t('Log out')}
          trigger={
            <Icon size='large' name='log out' style={{ color: 'white', cursor: 'pointer' }} />
          }
        />
      </Menu.Item>
    </>
  );

  return <>
    <Favicon url={favIcon} />
    <El.TopBarContainer>
      <El.LeftSideWrapper position='left'>{leftSide()}</El.LeftSideWrapper>
      <El.TopBarMenu>
        <El.RightSideWrapper position='right'>{rightSide()}</El.RightSideWrapper>
      </El.TopBarMenu>
    </El.TopBarContainer>
  </>
};

export default TopBar;